<template>
  <v-container>
    <head>
      <title>
        Foraje Sign In
      </title>
      <meta name="description" content="Sign in to your Foraje account">
    </head>
    <v-col cols="12" class="text-center">
      <h1>
        Sign In
      </h1>

    </v-col>
    <v-row  v-if="this.forgotpasswordalert">
      <v-col cols="12" sm="6" offset-sm="3">
        <v-alert dismissible @click.stop="onDismissedForgotPassword" color="primary" dark icon="mdi-email" :value="forgotpasswordalert" >Alright, an email with a link to reset your password was sent to the address you submitted</v-alert>
      </v-col>
    </v-row>
        <v-row >
      <v-col cols="12" sm="6" offset-sm="3">
        <v-alert dismissible color="error" text icon="mdi-alert-outline" v-model="erroralert" style="margin-bottom: 2px">
          {{errormessage}}
        </v-alert>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="SignIn">
                <v-row >
                  <v-col cols="12">
                    <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12">
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12">
                    <v-btn class= primary type="submit" :disabled="signinloading" :loading="signinloading">
                      Sign in
                      <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                    </v-btn>
                    <v-dialog v-model="forgotpassworddialog" max-width="800px">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="ml-3">
                          I Forgot My Password
                        </v-btn>
                      </template>
                      <v-card>

                        <v-alert dismissible @click.stop="onDismissedForgotPasswordError" :value="forgotpassworderroralert" color="error" icon="warning"><li v-if="this.forgotpassworderror">{{forgotpassworderror.response.data.email}}</li></v-alert>

                        <v-card-title class="headline"><u>Resetting Your Password</u></v-card-title>
                        <v-card-text>
                          <h4>
                          Enter the email you used to sign up for your Foraje account, and an email with password resetting instructions will be sent to you
                          </h4>
                          <v-row  >
                            <v-col cols="12" sm="8">
                              <v-text-field
                                name="forgotpasswordemail"
                                label="Email"
                                id="forgotpasswordemail"
                                v-model="forgotpasswordemail"
                                type="email"
                                hint="The email you used to sign up for Foraje"
                                required></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>

                        <v-card-actions>

                          <v-spacer></v-spacer>
                          <v-row >
                          <v-btn dark color="grey darken-1" @click.stop="forgotpassworddialog = false">Cancel</v-btn>
                          <v-btn color="primary" @click.stop="ForgotPassword" type="submit">Reset My Password!</v-btn>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import LOGIN_SUCCESS from 'src.store.modules.users.mutation-types'
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      password: '',
      erroralert: false,
      forgotpassworddialog: false,
      forgotpasswordalert: false,
      forgotpasswordemail: '',
      forgotpassworderroralert: false,
      forgotpassworderror: '',
      signinloading: false,
      signinmessage: '',
      errormessage: '',
    };
  },
  methods: {
    SignIn() {
      this.signinloading = true;
      return this.$store.dispatch('UserSignIn', { email: this.email, password: this.password })
        .then(() => {
          if (this.$store.getters.isLoggedIn === true) {
            this.signinloading = false;
            this.signinmessage = 'Login Successful!';
          }
        })
        .then(() => {
          if (this.$store.getters.isLoggedIn === true) {
            this.$router.push('/');
          }
        })
        .catch(
          (error) => {
            // kinda hacky until I edit the actual DRF error responses
            // regex to find content between two brackets
            const regex = /\[(.*?)\]/;
            // sets the error message to the content between [], and then removed the double quotes from that string. haaaacky.
            this.errormessage = regex.exec(error.response.request.response)[1].replace(/['"]+/g, '');
            this.erroralert = true;
            this.signinloading = false;
          },
        );
    },
    onDismissedForgotPassword() {
      this.forgotpasswordalert = false;
    },
    onDismissedForgotPasswordError() {
      this.forgotpassworderroralert = false;
      this.forgotpassworderror = '';
    },
    ForgotPassword() {
      return axios.post('rest-auth/password/reset/', { email: this.forgotpasswordemail })
        .then(() => {
          if (!this.forgotpassworderroralert) {
            this.forgotpassworddialog = false;
            this.forgotpasswordalert = true;
          }
        })
        .then(() => {
          if (this.forgotpassworderror) {
            this.forgotpassworderroralert = true;
          }
          this.forgotpassworderroralert = false;
        })
        .catch(
          (error) => {
            this.forgotpassworderror = error;
            this.forgotpassworderroralert = true;
          },
        );
    },

  },
};

// TODO add 'I forgot my password button, leading to component, or at least a dialog in this component that has the same functionality.
</script>
